import { gql, type TypedDocumentNode } from "@apollo/client";

export type RecentlyAssumedUserRow = {
  id: string;
  assumedAt: string;
  user: {
    id: string;
    name: string;
    email: string | null;
    photo?: string | null;
    department?: string | null;
  };
};

export type RecentlyAssumedUsersQueryResponse = {
  recentlyAssumedUsers: RecentlyAssumedUserRow[];
};

export type RecentlyAssumedUsersQueryVariables = {
  first?: number;
};

export const RECENTLY_ASSUMED_USERS_FIRST = 10;

export const RECENTLY_ASSUMED_USERS_QUERY: TypedDocumentNode<
  RecentlyAssumedUsersQueryResponse,
  RecentlyAssumedUsersQueryVariables
> = gql`
  query RecentlyAssumedUsers($first: Int) {
    recentlyAssumedUsers(first: $first) {
      id
      assumedAt
      user {
        id
        name
        email
        photo
        department
      }
    }
  }
`;
